/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value) {
    if (!('AllowedTransferFromMyGames' in value) || value['AllowedTransferFromMyGames'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AllowedTransferFromMyGames': json['AllowedTransferFromMyGames'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AllowedTransferFromMyGames': value['AllowedTransferFromMyGames'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions.js.map